module.exports = __webpack_public_path__ + "static/zillow2-08264dd4ab2e72d93132f3f04239edb9.jpg";